export default "__VITE_ASSET__CJHQ5feG__"